export const Contact = () => (
  <>
    <header className="page-header">
      <h1>Get in touch</h1>
      <p className="tagline">I'd love to hear from you</p>
    </header>
    <ul className="contact-list">
      <li><a href="https://www.linkedin.com/in/colleen-e-dixon">LinkedIn — colleen-e-dixon</a></li>
      <li><a href="https://www.twitter.com/auburn2001grad">Twitter — @auburn2001grad</a></li>
      <li><a href="https://github.com/colleendixon/projects">GitHub — colleendixon</a></li>
    </ul>
  </>
);
